import { useState, useEffect } from 'react';
import { useFirebase } from 'components/Firebase';

// Components
import Header from 'components/Header';
import BurgerMenu from 'components/BurgerMenu';
import Title from 'components/Title';
import PostCard from 'components/PostCard';
import Background from './background';

import { Container, Grid, Theme, useMediaQuery } from '@material-ui/core';

import './index.scss';

// Helpers
import { PostWithId } from 'components/Firebase/types';

const Home = (): JSX.Element => {
  const [posts, setPosts] = useState<PostWithId[]>([]);

  const firebase = useFirebase();

  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );

  useEffect(() => {
    firebase.getAllPosts().then((posts) => {
      setPosts(posts);
    });
  }, [firebase]);

  return (
    <div className="parallax-wrapper">
      {isSmallScreen ? <BurgerMenu /> : <Header />}

      <Background />
      <Container maxWidth="lg">
        <Grid container className="container">
          <Grid
            item
            className="title"
            xs={8}
            // onMouseEnter={onMouseEnterBackground}
            // onMouseLeave={onMouseLeaveBackground}
          >
            <Title />
          </Grid>
        </Grid>
        <Grid container justifyContent="center" spacing={4}>
          {posts.map((post, index) => (
            <Grid key={`post-${index}`} item xs={12} md={8} lg={6}>
              <PostCard
                id={post.id}
                thumbnail={post.thumbnailUrl}
                title={post.title}
                content={post.content}
                lastModifiedAt={post.lastModifiedAt}
              />
            </Grid>
          ))}
          {posts.length % 2 !== 0 && <Grid item xs={12} sm={8} md={6} />}
        </Grid>
      </Container>
    </div>
  );
};

export default Home;
